import { useCallback, useState } from "react";

export interface OtpCode {
  code: string;
  setCode: (code: string) => void;
  /** Bumped on every rejection: use it as the input's key so it remounts shaking. */
  shake: number;
  /** A rejected code: clear it and shake the input. */
  reject: () => void;
}

/** The 6-digit code typed into an OtpInput, and how it reacts to a wrong one. */
export function useOtpCode(): OtpCode {
  const [code, setCode] = useState("");
  const [shake, setShake] = useState(0);
  const reject = useCallback(() => {
    setShake((n) => n + 1);
    setCode("");
  }, []);
  return { code, setCode, shake, reject };
}
